import { useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTranslation } from 'react-i18next';

/**
 * Hook to enforce language settings based on the itHubI18N feature flag
 *
 * When the flag is false:
 * - Forces the app to use English only
 * - Prevents browser language detection from affecting the language
 *
 * When the flag is true:
 * - Allows normal multi-language support
 * - Browser language detection works as expected
 */
export const useI18nFeatureFlag = () => {
  const { itHubI18N } = useFlags();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (itHubI18N === false) {
      // Force English when the feature flag is disabled
      if (i18n.language !== 'en') {
        i18n.changeLanguage('en');
      }
    }
  }, [itHubI18N, i18n]);
};
